import { z } from 'zod';

import { BaseWidgetSchema } from './BaseWidgetSchema';
import { ProseMirrorJSONSchema } from './ProseMirrorJSONSchema';
import { WidgetType } from '../../utils/widgetsUtils';

export const BlockTitleWidgetStaticSchema = BaseWidgetSchema(WidgetType.BlockTitle).extend({
  textType: z.string(),
  /**
   * ProseMirror JSON
   */
  fragment: ProseMirrorJSONSchema,
  placeholder: z.string(),
  style: z.record(z.unknown())
});

export type BlockTitleWidgetStaticSchemaType = z.infer<typeof BlockTitleWidgetStaticSchema>;
